import { Outlet } from 'react-router-dom';
import { AdminHeader } from './AdminHeader';
import styles from './Layout.scss';
import { PRODUCTION } from '@shared/environments';
import { useAuth } from 'restaurantAdmin/context/AuthContext';
import { MessagingDrawer } from 'restaurantAdmin/messaging/MessagingDrawer';

interface LayoutProps {
  children?: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const { isSuperAdmin } = useAuth();
  const isProduction = process.env.ENV === PRODUCTION;

  return (
    <>
      {isSuperAdmin && isProduction && (
        <div className={styles.superAdminBanner}>
          <p>You are logged in as a Super Admin. Be careful!</p>
        </div>
      )}
      <AdminHeader />
      <main className={styles.main}>
        <Outlet />
        {children}
        <MessagingDrawer />
      </main>
    </>
  );
};
